import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { Route as ImplementationDetailsRoute } from '~/core/routes/implementations/[implementationId]/_index';
import { Route as CreditAgreementDetailRoute } from '~/core/routes/implementations/[implementationId]/credit-facilities/[creditFacilityId]/credit-agreements/[creditAgreementId]/_index';
import { Route as CreditAgreementsListRoute } from '~/core/routes/implementations/[implementationId]/credit-facilities/[creditFacilityId]/credit-agreements/_index';
import { Route as CreditAgreementWipRoute } from '~/core/routes/implementations/[implementationId]/credit-facilities/[creditFacilityId]/credit-agreements/wip/_index';
import { Route as TapeBuilderRoute } from '~/core/routes/implementations/[implementationId]/tape-builder/_index';
import { Route as ImplementationsListRoute } from '~/core/routes/implementations/_index';

// Exports
export const permissions: PermissionsFn = (context) => {
  // This provides a read-only view of implementations for the core dashboard
  return context.flags.productsImplementationsOnCoreDashboard;
};

export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <Outlet />
    </PermissionGuard>
  ),
  // Relative to /implementations/*
  children: [
    { index: true, element: <ImplementationsListRoute /> },
    { path: ':implementationId', element: <ImplementationDetailsRoute /> },
    {
      path: ':implementationId/*',
      children: [
        {
          index: true,
          element: <ImplementationDetailsRoute />,
        },
        {
          path: 'tape-builder',
          element: <TapeBuilderRoute />,
        },
        {
          path: 'credit-facilities/:creditFacilityId/credit-agreements',
          element: <CreditAgreementsListRoute />,
        },
        {
          path:
            'credit-facilities/:creditFacilityId/credit-agreements/:creditAgreementId',
          element: <CreditAgreementDetailRoute />,
        },
        {
          path: 'credit-facilities/:creditFacilityId/credit-agreements/wip',
          element: <CreditAgreementWipRoute />,
        },
      ],
    },
    { path: '*', element: <Navigate to="./" replace /> },
  ],
};
